import { createContext } from 'react';

export type RetriggerWebhookResponseCtx = {
  showRetriggerSuccessAlert: boolean;
  retriggerError: string;
  showRetriggerWebhookErrorAlert: boolean;
};

const RetriggerWebhookResponse = createContext<RetriggerWebhookResponseCtx>({
  showRetriggerSuccessAlert: false,
  retriggerError: '',
  showRetriggerWebhookErrorAlert: false,
});

export default RetriggerWebhookResponse;
